import Http from '../utils/axios'
const rt = '/api-zendai-b'
const user_b = '/user-b'
const finance = '/finance'
const user = "/user";
const investment = "/investment";
const operation='/operation'
// http://bgy.dev.rscloud.com/api-zendai-b/finance/b/pay/list

export default {
    //登录接口
    login(params) {
        return Http.post(`${rt}${user_b}/b/login`, params)
    },
    //缴费列表清单
    page(params) {
        return Http.post(`${rt}${finance}/b/pay/list`, params)
    },
    //缴费流水 /b/pay/getPayRecordList
    getPayRecordList(params) {
        return Http.post(`${rt}${finance}/b/pay/getPayRecordList`, params)
    },
    //未缴费金额
    paygetTotalUnpaidAmount(params) {
        return Http.post(`${rt}${finance}/b/pay/getTotalUnpaidAmount`, params)
    },
    //已缴费金额
    getTotalPaidAmount(params) {
        return Http.post(`${rt}${finance}/b/pay/getTotalPaidAmount`, params)
    },
    //统一预下单  GET /b/pay/unifiedPreOrder7011
    unifiedPreOrder7011(params) {
        return Http.get(`${rt}${finance}/b/pay/unifiedPreOrder7011`, params)
    },
	unifiedPreOrder9004(params) {
	    return Http.get(`${rt}${finance}/b/pay/unifiedPreOrder9004`, params)
	},
    //商户订单编号获取缴费流水  GET /b/pay/getPayRecordByMerOrderNo
    getPayRecordByMerOrderNo(params) {
        return Http.get(`${rt}${finance}/b/pay/getPayRecordByMerOrderNo`, params)
    },
	//获取余额
	selectPreReceiptTotalByBusinessId(params){
		return Http.get(`${rt}${finance}/b/pay/selectPreReceiptTotalByBusinessId`, params)
	},
        

    //商户列表
    investLesseeAccountlist(params) {
        return Http.post(`${rt}${investment}/v1/b/investLesseeAccount/list`, params)
    },
    //详细信息
    lesseedetail(params) {
        return Http.get(`${rt}${investment}/b/lessee/detailByMallCode`, params)
    },
    //账号新增
    addcreateOrEditLesseeAccount(params) {
        return Http.post(`${rt}${investment}/v1/b/investLesseeAccount/createOrEditLesseeAccount`, params)
    },
    //账号修改
    putcreateOrEditLesseeAccount(params) {
        return Http.post(`${rt}${investment}/v1/b/investLesseeAccount/createOrEditLesseeAccount`, params)
    },
    //密码重置
    unpdatePassword(params){
        return Http.post(`${rt}${investment}/v1/b/investLesseeAccount/createOrEditLesseeAccount`,params)
    },
	//禁用账号
	delLessAccount(params){
		return Http.post(`${rt}${investment}/v1/b/investLesseeAccount/disableEnable`,params)
	},
	//平台公告
	announCement(params){
		return Http.post(`${rt}${operation}/v1/b/notice/findBusinessNotice`,params)
	},
	//公告详情
	announCemementDeatil(params){
		return Http.get(`${rt}${operation}/v1/b/notice/getBusinessNotice`,params)
	}
};